export default () => ({
  index: 0,
  valueLabel: null,
  options: [],
  input: {
    ["x-init"]: function () {
      this.index = Number(this.$el.value);
    },
    ["x-model.number"]: "index",
    ["x-on:change"]: function () {
      this.valueLabel = this.options[this.index].label;
    },
    [":style"]: function () {
      const progress = (this.index / (this.options.length - 1)) * 100;
      return {
        backgroundImage: `linear-gradient(to right, #E55C53 ${progress}%, #FFD1CE ${progress}%)`,
      };
    },
  },
  datalist: {
    ["x-init"]: function () {
      this.options = Array.from(this.$el.options);
      if (this.index !== null) {
        this.valueLabel = this.options[this.index].label;
      }
    },
  },
});
